import { create } from 'zustand';
import type { PlatformActor } from '@/types/platform';
import { platformServices, ServiceError } from '@/services';
import type { PlatformPermission } from '@/lib/permissions';

interface PlatformSessionState {
  actor: PlatformActor | null;
  error: ServiceError | Error | null;
  loading: boolean;
  load: () => Promise<void>;
  reset: () => void;
}

/** Client mirror of the future `GET /api/platform/me`. Drives navigation only; the server enforces access. */
export const usePlatformSession = create<PlatformSessionState>((set) => ({
  actor: null,
  error: null,
  loading: true,
  load: async () => {
    set({ loading: true, error: null });
    try { set({ actor: await platformServices.session.me(), loading: false }); }
    catch (e) { set({ actor: null, error: e instanceof Error ? e : new Error(String(e)), loading: false }); }
  },
  reset: () => set({ actor: null, error: null, loading: true }),
}));

export const useCanPlatform = (perm: PlatformPermission) => usePlatformSession((s) => !!s.actor && s.actor.permissions.includes(perm));
